import { useTheme} from "@mui/material";
import {observer} from 'mobx-react';
import {useNavigate, useParams} from "react-router-dom";
import * as React from "react";
import AssignRolesFeature from "./AssignRolesFeature";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import FormSection from "../../../forms/FormSection";
import LayoutContentToolbar from "../../../components/layout/LayoutContentToolbar";
import {USERS_PATH} from "../../../routes";
import {styles} from "./AssignRolesStyles";
import {useNavigatorFeature} from "../../../useFeature";
import {useApplication} from "../../../ApplicationProvider";
import FormAutocompleteMultipleSelectField from "../../../components/fields/FormAutocompleteMultipleSelectField";


function AssignRolesScreen() {
    const application = useApplication();
    const theme = useTheme();
    const navigator = useNavigate();
    const {id} = useParams();
    const feature = useNavigatorFeature(() => new AssignRolesFeature(application, navigator, id), navigator, [id])
    const style = styles(theme);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const currentAccountContent = () => {
        return isFeatureReady(feature) && (
            <div>
                <LayoutContentToolbar
                    title={`Usuario ${feature.userEmail()}`}
                    breadcrumbs={[
                        {label: 'Usuarios Marketplace', path: USERS_PATH},
                        {label: `Usuario ${feature.userEmail()}`},
                    ]}
                />
                <FormSection title="Clientes">
                        <FormAutocompleteMultipleSelectField label={'Clientes asignados'}
                                                             field={feature.form.getFieldByName("customers")}
                                                             options={feature.customersFieldOptions()}
                                                             onChipDelete={(removedValue => {
                                                                 feature.handleCustomerChipDelete(removedValue)
                                                             })}/>
                </FormSection>

                <FormSection title="Puntos de Entrega">
                            <FormAutocompleteMultipleSelectField label={'Puntos de entrega asignados'}
                                                                 field={feature.form.getFieldByName("deliverySites")}
                                                                 options={feature.deliverySitesFieldOptions()}
                                                                 isOptionEqualToValue={(option, value) =>
                                                                     option.value.businessName === value.businessName &&
                                                                     option.value.code === value.code
                                                                 }
                            />
                </FormSection>

                <FormSection title="Roles">
                    <FormAutocompleteMultipleSelectField label={'Rol'} field={feature.form.getFieldByName("roles")}
                                           options={feature.rolesFieldOptions()}/>
                </FormSection>
            </div>
        )
    }
    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => currentAccountContent()}/>
    );
}

export default observer(AssignRolesScreen);
